import { CircularProgress } from '@mui/material';
import { twMerge } from 'tailwind-merge';

type SpinnerProps = {
  containerClassName?: string;
  centerPage?: boolean;
};

export const Spinner : React.FC<SpinnerProps> = ({ containerClassName, centerPage = true }) => {
  const centeredSpinnerClassName = twMerge('flex h-full w-full justify-center items-center', containerClassName);

  return (
    <div
      data-cy="spinner"
      role="status"
      className={centerPage ? centeredSpinnerClassName : containerClassName}
    >
      <CircularProgress size={32} />
      <span className="sr-only">Loading...</span>
    </div>
  );
};
